import { Pipe, PipeTransform } from '@angular/core';

import {
  isProductActive,
  isUserAllowedToAccessToProduct,
} from 'src/app/constants/constants';

@Pipe({ name: 'hasUserSmw' })
export class HasUserSmwPipe implements PipeTransform {
  transform(
    stationId: any,
    isMaster: boolean,
    customerAlias: any,
    customerDocument: any,
    hasUserWebAccess: boolean,
    userMetaData: any,
    isUserAdminMode?: boolean
  ) {
    if (
      isProductActive(
        isMaster,
        customerAlias,
        customerDocument,
        hasUserWebAccess,
        userMetaData,
        'smwProducts'
      )
    ) {
      for (const smwProduct of customerDocument['smwProducts']) {
        if (
          isProductActive(
            isMaster,
            customerAlias,
            customerDocument,
            hasUserWebAccess,
            userMetaData,
            'smwProducts',
            smwProduct.id
          )
        ) {
          for (const station of smwProduct.stations) {
            if (station.stationId == stationId) {
              if (
                isUserAllowedToAccessToProduct(
                  userMetaData,
                  smwProduct.id,
                  isUserAdminMode,
                  stationId,
                  true
                )
              ) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
}
